import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__copyright">
        <p>&#169;Copyright Walid B. {new Date().getFullYear()}</p>
      </div>
    </footer>
  );
};

export default Footer;
